// Client for the Wei Care backend (/api/weicare on kv_backend).
// REACT_APP_API_URL is the backend origin, e.g. http://localhost:5002;
// empty means same origin (production, behind the same host).

const ORIGIN = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');
export const API_ROOT = `${ORIGIN}/api/weicare`;

const TOKEN_KEY = 'weicare.staffToken';

// Session storage: a staff sign-in ends with the browser tab, and the token
// never outlives the backend's 12-hour expiry anyway.
export const staffToken = {
  get: () => { try { return sessionStorage.getItem(TOKEN_KEY); } catch { return null; } },
  set: (t) => { try { sessionStorage.setItem(TOKEN_KEY, t); } catch { /* storage blocked */ } },
  clear: () => { try { sessionStorage.removeItem(TOKEN_KEY); } catch { /* storage blocked */ } },
};

export class ApiError extends Error {
  constructor(status, body) {
    super((body && body.message) || `Request failed (${status})`);
    this.status = status;
    this.code = body && body.code;
    this.errors = (body && body.errors) || [];
    this.body = body;
  }
}

const NETWORK_MESSAGE = 'We could not reach Wei Care. Check your connection and try again.';

/**
 * @param {string} path  relative to /api/weicare, e.g. '/sign/ABC'
 * @param {{ method?, body?, form?, auth?, raw? }} opts
 */
export async function api(path, { method = 'GET', body, form, auth = false, raw = false } = {}) {
  const headers = {};
  if (body !== undefined) headers['Content-Type'] = 'application/json';
  if (auth) {
    const t = staffToken.get();
    if (t) headers.Authorization = `Bearer ${t}`;
  }
  let res;
  try {
    res = await fetch(`${API_ROOT}${path}`, {
      method,
      headers,
      body: form || (body !== undefined ? JSON.stringify(body) : undefined),
    });
  } catch {
    throw new ApiError(0, { code: 'network', message: NETWORK_MESSAGE });
  }
  if (raw && res.ok) return res;
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    if (res.status === 401 && auth) {
      staffToken.clear();
      window.dispatchEvent(new Event('weicare:signed-out'));
    }
    throw new ApiError(res.status, data);
  }
  return data;
}
